
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Display } from './model/Display'
import { WebPlayerThemeUtil } from './utils/WebPlayerThemeUtil'
import { WebPlayer } from '~/api'

@Component
export default class WebPlayerDisplay extends Vue {
  @Prop() display!: Display
  @Prop() platformSettings!: WebPlayer
  @Prop() isFullScreen!: boolean

  get displayClass() {
    return WebPlayerThemeUtil.displayClass(this.platformSettings)
  }
}
